<div>
  <h2>{{ text }}</h2>

  <div class="confirm-actions">
    <button mat-raised-button (click)="close(true)">{{ confirmText }}</button>
    <button mat-raised-button color="warn" (click)="close(false)">{{ cancelText }}</button>
  </div>
</div>
